export default {
  meta: {
    title: '区域详情',
    url: '/recommend/modal', // 埋点用，记录所属模块
    parentPath: ['/recommend'],
    breadcrumbs: {
      path: ['/recommend/modal'],
      name: ['开店区域推荐'],
    },
  },
};
